<template>
  <div>
    <div v-for="item in requests" :key="item.index" class="site-request mb-2">
      <div v-if="item.type === 'site'" class="flex-between flex-v-center flex-wrap-xs">
        <div class="mr-1 mb-1-xs">
          <span class="text-bold text-md">{{item.data}}</span><br>
          <span class="text-sm">{{ profile.kidName !== '' ? profile.kidName : 'Kid' }} {{$lang.messages.statistic.site_request}}</span>
        </div>
        <div class="text-right">
          <button class="btn btn-outline" @click="moveToLinks(item)">{{$lang.messages.statistic.site_request_accept}}</button>
          <button class="btn btn-main" @click="removeRequest(item)">{{$lang.messages.statistic.site_request_block}}</button>
        </div>
      </div>
      <div v-if="item.type === 'time'">
        <div class="flex-between flex-v-center">
          <div class="mr-1 text-uppercase text-md text-bold">
            {{ profile.kidName != '' ? profile.kidName : 'Kid' }} {{$lang.messages.statistic.time_request}}
          </div>
          <button @click="removeRequest(item)" class="btn btn-outline">{{$lang.messages.cancel}}</button>
        </div>
        <hr>
        <div class="flex-between flex-v-center flex-column-xs">
          <div class="text-sm mb-xs-1">
            {{ profile.kidName != '' ? profile.kidName : 'Kid' }} {{$lang.messages.statistic.time_request_text}}
          </div>
          <div class="flex flex-v-center">
            <v-select class="feature-lock-time-select" :searchable="false" :clearable="false" v-model="addTime" :options="addTimeOptions" :reduce="item => item.value" label="label">
              <template slot="open-indicator">
                <svg class="vs__open-indicator" width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 0.5L5.5 5L10 0.5" stroke="#7D6AED"/>
                </svg>
              </template>
            </v-select>
            <button class="ml-1 btn btn-main" @click="addMoreTime">{{$lang.messages.ok}}</button>
          </div>
        </div>
      </div>
      <div v-if="item.type === 'unavailable'">
        <div class="flex-between flex-v-center">
          <div class="mr-1 text-uppercase text-md text-bold">
            {{$lang.messages.statistic.time_request}}
          </div>
          <button class="btn btn-outline" @click="removeRequest(item)">{{$lang.messages.cancel}}</button>
        </div>
        <hr>
        <div class="flex-between flex-v-center">
          <div class="text-sm">
            {{$lang.messages.statistic.unavailable_request_text}}
          </div>
          <div>
            <button class="ml-1 btn btn-main" @click="openMenuItem('ProfileLimits'); removeRequest(item)">{{ $lang.messages.statistic.go_settings }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import saveSetting from "@/components/mixins/saveSetting";
import {mapState} from "vuex";

export default {
  name: 'Requests',
  props: ['profileId'],
  mixins: [saveSetting],
  data: function (){
    return {
      addTime: 1800,
      addTimeOptions: [{
        label: '+ 30 min',
        value: 1800
      },
        {
          label: '+ 1 hour',
          value: 3600
        },
        {
          label: '+ 2 hours',
          value: 7200
        }],
    }
  },
  computed: {
    ...mapState({
      user: state => state.user.uid,
      profiles: state => state.accountData.profiles,
      isPremium: state => state.accountData.isPremium
    }),
    requests(){
      return this.profiles[this.profileId].requests
    },
    profile(){
      return this.profiles[this.profileId]
    }
  },
  methods: {
    removeRequest(request) {
      let newRequests

      if (request.type === 'site'){
        newRequests = this.requests.filter(item => item.type == 'time' || (item.type == 'site' && item.data.url !== request.data.url));
      } else if (request.type === 'time'){
        newRequests = this.requests.filter(item => item.type == 'site' || item.type == 'unavailable')
      } else {
        newRequests = this.requests.filter(item => item.type == 'site' || item.type == 'time')
      }
      this.saveProfileSettings(this.profileId, {requests: newRequests.length ? newRequests : null})
    },
    addMoreTime() {
      this.saveProfileSettings(this.profileId, {'todayDailyLimit': this.profile.todayDailyLimit + this.addTime})
      this.removeRequest({type: 'time'})
    },
    moveToLinks(item) {
      const link = this.getLinkData(item.data)
      this.profile.links.push(link);
      this.saveProfileSettings(this.profileId, {links: this.profile.links})
      this.removeRequest(item);
    },
    openMenuItem (title, addInfo) {
      this.$emit('openmenuitem', title, addInfo);
    },
    getLinkData(url){
      const {origin, hostname} = new URL(url);
      const icon = 'https://www.google.com/s2/favicons?sz=64&domain=' + origin
      return {
        id: Date.now(),
        title: hostname,
        url: origin,
        icon: icon
      }
    },
  },
}

</script>

